import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { InboxPage } from 'src/pages';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <InboxPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.inbox.inboxItem,
    element: <InboxPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.inbox.inboxTestRequests,
    element: <InboxPage />,
    accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
  },
  {
    path: appRoutes.inbox.inboxTestRequestItem,
    element: <InboxPage />,
    accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
  },
];

export const INBOX_ROUTE: RouteProps = {
  path: appRoutes.inbox.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized, ReactRouteAccessKey.isNotPartnershipCompanyUser],
};
